import React from 'react';
import { CTAButton } from './CTAButton';
export function FinalCTASection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-cream px-4 py-24 text-center" data-id="element-51">
      <div className="mx-auto max-w-xl rounded-[2rem] border-2 border-brand-green bg-white p-8 shadow-xl md:p-12" data-id="element-52">
        <p className="mb-4 text-sm font-bold uppercase tracking-[0.15em] text-brand-green" data-id="element-53">
          Dein komplettes Jahres-Kit
        </p>
        <h2 className="mb-5 text-3xl font-black text-brand-text md:text-4xl" data-id="element-54">
          🏆 Spezielles Launch-Angebot
        </h2>
        <div className="mb-2 flex items-center justify-center gap-3" data-id="element-55">
          <span className="text-4xl" aria-hidden="true" data-id="element-56">
            🏆
          </span>
          <span className="text-6xl font-black tracking-tight text-brand-green md:text-7xl" data-id="element-57">
            19 €
          </span>
        </div>
        <p className="mb-8 text-lg font-medium text-brand-gray line-through" data-id="element-58">
          142 €
        </p>
        <CTAButton onClick={scrollToPricing} className="mb-6 w-full py-5 text-base md:text-lg" data-id="element-59">
          ICH WILL DAS YOGA BEREIT KIT
        </CTAButton>
        <p className="text-xs font-medium leading-relaxed text-brand-gray" data-id="element-60">
          Sofortiger Download &middot; Einmalzahlung &middot; Lebenslanger
          Zugang &middot; 7 Tage Garantie
        </p>
      </div>
    </section>;
}